/* Ezee Notes theme */
(function () {
  'use strict';

  var T = window.ezTheme || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js' } };
  var lastAdded = null;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }
  function store(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key);
      if (value === null) window.sessionStorage.removeItem(key);
      else window.sessionStorage.setItem(key, value);
    } catch (e) { /* storage can be blocked */ }
    return null;
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(message) {
    var old = $('.ez-toast');
    if (old) old.remove();
    var t = el('div', 'ez-toast', message);
    t.setAttribute('role', 'status');
    document.body.appendChild(t);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.remove(); }, 4000);
  }

  /* ---------- Dialogs ---------- */
  function openDialog(d) {
    if (!d) return;
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); }
    else d.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDialog(d) {
    if (!d) return;
    if (typeof d.close === 'function' && d.open) d.close();
    else { d.removeAttribute('open'); afterClose(d); }
  }
  function afterClose(d) {
    if (d.id === 'EzVideo') {
      var frame = $('[data-ez-video-frame]', d);
      if (frame) { frame.innerHTML = ''; frame.style.aspectRatio = ''; }
    }
    if (d.id === 'EzSamples') {
      var view = $('[data-ez-sample-view]', d);
      if (view) view.innerHTML = '';
    }
    if (!$('dialog[open]')) document.documentElement.style.overflow = '';
  }
  document.addEventListener('close', function (e) {
    if (e.target && e.target.tagName === 'DIALOG') afterClose(e.target);
  }, true);

  /* ---------- Cart ---------- */
  function setCount(n) {
    $$('[data-ez-cart-count]').forEach(function (b) {
      b.textContent = n;
      b.setAttribute('data-count', n);
    });
  }
  function cartRequest(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
        return j;
      });
    });
  }
  function sectionIds() {
    var ids = ['ez-cart-sheet'];
    var c = $('[data-ez-cart]');
    if (c) ids.push(c.getAttribute('data-section-id'));
    return ids.join(',');
  }
  function showSheetLine() {
    var lines = $$('.ez-sheet__line');
    if (!lines.length) return;
    var hit = null;
    lines.forEach(function (l) {
      l.hidden = true;
      if (lastAdded && l.getAttribute('data-variant') === String(lastAdded)) hit = l;
    });
    (hit || lines[0]).hidden = false;
  }
  function applySections(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    var sheetHtml = sections['ez-cart-sheet'];
    if (sheetHtml) {
      var fresh = parser.parseFromString(sheetHtml, 'text/html').querySelector('[data-ez-sheet]');
      var cur = $('[data-ez-sheet]');
      if (fresh && cur) {
        cur.innerHTML = fresh.innerHTML;
        setCount(fresh.getAttribute('data-cart-count'));
        showSheetLine();
      }
    }
    var cart = $('[data-ez-cart]');
    if (cart) {
      var id = cart.getAttribute('data-section-id');
      if (sections[id]) {
        var wrap = document.getElementById('shopify-section-' + id);
        var freshWrap = parser.parseFromString(sections[id], 'text/html').getElementById('shopify-section-' + id);
        if (wrap && freshWrap) wrap.innerHTML = freshWrap.innerHTML;
        var c2 = $('[data-ez-cart]');
        if (c2) setCount(c2.getAttribute('data-cart-count'));
      }
    }
  }
  function busy(node, on) {
    if (!node) return;
    node.classList.toggle('is-loading', on);
    if (on) node.setAttribute('aria-busy', 'true'); else node.removeAttribute('aria-busy');
    if ('disabled' in node) node.disabled = on;
  }
  function addToCart(variantId, btn, openSheet) {
    busy(btn, true);
    return cartRequest(T.routes.cartAdd, { items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds() })
      .then(function (res) {
        if (openSheet) lastAdded = variantId;
        applySections(res.sections);
        if (openSheet) {
          closeDialog($('#EzSamples'));
          openDialog($('#EzCartSheet'));
        }
      })
      .catch(function (err) { toast(err.message); })
      .then(function () { busy(btn, false); });
  }
  function changeLine(key, quantity, btn) {
    var cart = $('[data-ez-cart]');
    if (cart) cart.classList.add('is-busy');
    busy(btn, true);
    return cartRequest(T.routes.cartChange, { id: key, quantity: quantity, sections: sectionIds() })
      .then(function (res) { applySections(res.sections); })
      .catch(function (err) { toast(err.message); })
      .then(function () {
        busy(btn, false);
        var c = $('[data-ez-cart]');
        if (c) c.classList.remove('is-busy');
      });
  }

  /* ---------- Video and zoom ---------- */
  /* A video plays where its card is: the card is hidden and a player of the same shape takes its place. */
  var playing = null;
  function stopVideo() {
    if (!playing) return;
    playing.box.remove();
    playing.trigger.hidden = false;
    playing = null;
  }
  function playVideo(trigger) {
    var yt = trigger.getAttribute('data-ez-video');
    var src = trigger.getAttribute('data-ez-video-src');
    if (!yt && !src) return;
    stopVideo();
    var box = el('div', trigger.className + ' is-playing');
    if (trigger.classList.contains('ez-reel') && !trigger.hasAttribute('data-vertical')) box.classList.add('ez-reel--wide');
    var label = (trigger.getAttribute('aria-label') || 'Video').replace(/^Play( video)?:\s*/, '');
    if (src) {
      var v = document.createElement('video');
      v.src = src; v.controls = true; v.autoplay = true; v.playsInline = true;
      v.setAttribute('aria-label', label);
      box.appendChild(v);
    } else {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(yt) + '?autoplay=1&rel=0&playsinline=1';
      f.title = label;
      f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      f.allowFullscreen = true;
      box.appendChild(f);
    }
    trigger.parentNode.insertBefore(box, trigger);
    trigger.hidden = true;
    playing = { box: box, trigger: trigger };
  }
  /* The Instagram video of a card that starts as a cover: the embed is added behind the cover and shown once it has loaded */
  function mountInstagram(card) {
    if (!card || $('iframe', card)) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.instagram.com/p/' + encodeURIComponent(card.getAttribute('data-ez-ig')) + '/embed/';
    f.title = card.getAttribute('data-title') || 'Instagram video';
    f.setAttribute('scrolling', 'no');
    f.allow = 'autoplay; encrypted-media; picture-in-picture; clipboard-write';
    f.allowFullscreen = true;
    f.addEventListener('load', function () { card.classList.add('is-live'); });
    card.appendChild(f);
  }
  function initInstagram() {
    var cards = $$('[data-ez-ig]');
    if (!cards.length) return;
    // After the page has loaded, so the embed never slows the first view
    function later() { setTimeout(function () { cards.forEach(mountInstagram); }, 1200); }
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
  }
  function zoomImage(url, alt) {
    var d = $('#EzVideo');
    var frame = d && $('[data-ez-video-frame]', d);
    if (!frame) return;
    frame.innerHTML = '';
    frame.style.aspectRatio = 'auto';
    var img = document.createElement('img');
    img.src = url; img.alt = alt || '';
    img.style.cssText = 'width:100%;height:auto;max-height:86vh;object-fit:contain;background:#fff;display:block';
    frame.appendChild(img);
    openDialog(d);
  }

  /* ---------- Sample PDFs ---------- */
  function openSample(btn) {
    var d = $('#EzSamples');
    if (!d) { window.open(btn.getAttribute('data-href'), '_blank', 'noopener'); return; }
    var seen = {};
    var list = [];
    $$('[data-ez-sample]').forEach(function (b) {
      var s = b.getAttribute('data-src');
      if (b.closest('#EzSamples') || seen[s]) return;
      seen[s] = true;
      list.push({ src: s, href: b.getAttribute('data-href'), label: b.getAttribute('data-label') });
    });
    var tabs = $('[data-ez-sample-tabs]', d);
    var view = $('[data-ez-sample-view]', d);
    var title = $('#EzSamplesTitle', d);
    var open = $('[data-ez-sample-open]', d);
    function show(item) {
      title.textContent = item.label + ' sample';
      open.href = item.href;
      view.innerHTML = '';
      var f = document.createElement('iframe');
      f.src = item.src; f.title = item.label + ' sample PDF'; f.loading = 'eager';
      f.allow = 'autoplay';
      view.appendChild(f);
      $$('button', tabs).forEach(function (t) { t.setAttribute('aria-pressed', String(t.getAttribute('data-src') === item.src)); });
    }
    tabs.innerHTML = '';
    list.forEach(function (item) {
      var t = el('button', 'ez-pdf', item.label);
      t.type = 'button';
      t.setAttribute('data-src', item.src);
      t.addEventListener('click', function () { show(item); });
      tabs.appendChild(t);
    });
    tabs.hidden = list.length < 2;
    var current = list.filter(function (i) { return i.src === btn.getAttribute('data-src'); })[0] || list[0];
    openDialog(d);
    if (current) show(current);
  }

  /* ---------- Class pages: subject filter ---------- */
  function initShelf() {
    var shelf = $('[data-ez-shelf]');
    var box = $('[data-ez-subject-chips]');
    if (!shelf || !box) return;
    var items = $$('[data-ez-item]', shelf);
    var subjects = [];
    items.forEach(function (i) {
      (i.getAttribute('data-subjects') || '').split(',').forEach(function (s) {
        if (s && subjects.indexOf(s) === -1) subjects.push(s);
      });
    });
    if (subjects.length < 2) return;
    var counter = $('[data-ez-count]', shelf);
    function apply(subject) {
      var n = 0;
      items.forEach(function (i) {
        var has = subject === 'All' || (',' + i.getAttribute('data-subjects')).indexOf(',' + subject + ',') !== -1;
        i.hidden = !has;
        if (has) n += 1;
      });
      if (counter) counter.textContent = n + (n === 1 ? ' book' : ' books') + (subject === 'All' ? '' : ' with ' + subject);
      $$('button', box).forEach(function (b) { b.setAttribute('aria-pressed', String(b.textContent === subject)); });
    }
    ['All'].concat(subjects).forEach(function (s) {
      var b = el('button', 'ez-chip', s);
      b.type = 'button';
      b.setAttribute('aria-pressed', String(s === 'All'));
      b.addEventListener('click', function () { apply(s); });
      box.appendChild(b);
    });
    box.hidden = false;
  }

  /* ---------- Product gallery: swipe between photos, pinch or double-tap to zoom ---------- */
  function initGallery() {
    var track = $('[data-ez-track]');
    if (!track) return;
    var slides = $$('[data-ez-slide]', track);
    var thumbBox = $('[data-ez-thumbs]');
    var thumbs = $$('[data-ez-thumb]');
    var counter = $('[data-ez-slide-no]');
    var index = 0;
    var zoom = { scale: 1, x: 0, y: 0, img: null };
    var gesture = null;
    var lastTap = { time: 0, x: 0, y: 0 };
    var MAX = 4;

    function setIndex(i) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      if (counter) counter.textContent = index + 1;
      thumbs.forEach(function (b) {
        var on = Number(b.getAttribute('data-ez-thumb')) === index;
        b.setAttribute('aria-pressed', String(on));
        if (on && thumbBox) {
          var left = b.offsetLeft - thumbBox.offsetLeft - (thumbBox.clientWidth - b.offsetWidth) / 2;
          thumbBox.scrollTo({ left: left, behavior: 'smooth' });
        }
      });
    }
    function draw() {
      if (!zoom.img) return;
      zoom.img.style.transform = zoom.scale > 1 ? 'translate(' + zoom.x + 'px,' + zoom.y + 'px) scale(' + zoom.scale + ')' : '';
      track.classList.toggle('is-zoomed', zoom.scale > 1);
    }
    function limit() {
      var w = track.clientWidth, h = track.clientHeight;
      zoom.x = Math.min(0, Math.max(w - w * zoom.scale, zoom.x));
      zoom.y = Math.min(0, Math.max(h - h * zoom.scale, zoom.y));
    }
    // Zoom to `scale`, keeping the point (cx, cy) of the photo under the fingers
    function zoomAt(cx, cy, scale) {
      scale = Math.max(1, Math.min(MAX, scale));
      var k = scale / zoom.scale;
      zoom.x = cx - (cx - zoom.x) * k;
      zoom.y = cy - (cy - zoom.y) * k;
      zoom.scale = scale;
      limit();
      draw();
    }
    function resetZoom() {
      zoom.scale = 1; zoom.x = 0; zoom.y = 0;
      draw();
    }
    function goTo(i, smooth) {
      resetZoom();
      setIndex(i);
      track.scrollTo({ left: index * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    }
    function point(t) {
      var r = track.getBoundingClientRect();
      return { x: t.clientX - r.left, y: t.clientY - r.top };
    }
    function spread(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }

    track.addEventListener('scroll', function () {
      if (zoom.scale > 1) return;
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== index) setIndex(i);
    }, { passive: true });

    track.addEventListener('touchstart', function (e) {
      zoom.img = $('img', slides[index]);
      if (e.touches.length === 2) {
        e.preventDefault();
        gesture = { type: 'pinch', dist: spread(e.touches[0], e.touches[1]), scale: zoom.scale };
      } else if (e.touches.length === 1 && zoom.scale > 1) {
        gesture = { type: 'pan', from: point(e.touches[0]), x: zoom.x, y: zoom.y };
      } else {
        gesture = null;
      }
    }, { passive: false });

    track.addEventListener('touchmove', function (e) {
      if (!gesture) return;
      if (gesture.type === 'pinch' && e.touches.length === 2) {
        e.preventDefault();
        var a = point(e.touches[0]), b = point(e.touches[1]);
        zoomAt((a.x + b.x) / 2, (a.y + b.y) / 2, gesture.scale * spread(e.touches[0], e.touches[1]) / gesture.dist);
      } else if (gesture.type === 'pan' && e.touches.length === 1) {
        e.preventDefault();
        var p = point(e.touches[0]);
        zoom.x = gesture.x + p.x - gesture.from.x;
        zoom.y = gesture.y + p.y - gesture.from.y;
        limit();
        draw();
      }
    }, { passive: false });

    track.addEventListener('touchend', function (e) {
      if (zoom.scale < 1.05) resetZoom();
      if (e.touches.length === 1 && zoom.scale > 1) {
        gesture = { type: 'pan', from: point(e.touches[0]), x: zoom.x, y: zoom.y };
        return;
      }
      if (e.touches.length) return;
      var wasPinch = gesture && gesture.type === 'pinch';
      gesture = null;
      var t = e.changedTouches[0];
      if (!t || wasPinch) return;
      var p = point(t), now = Date.now();
      if (now - lastTap.time < 320 && Math.abs(p.x - lastTap.x) < 30 && Math.abs(p.y - lastTap.y) < 30) {
        e.preventDefault();
        zoom.img = $('img', slides[index]);
        if (zoom.scale > 1) resetZoom(); else zoomAt(p.x, p.y, 2.5);
        lastTap.time = 0;
      } else {
        lastTap = { time: now, x: p.x, y: p.y };
      }
    }, { passive: false });
    track.addEventListener('touchcancel', function () { gesture = null; });
    // Safari sends its own pinch events; without this it would zoom the whole page instead
    track.addEventListener('gesturestart', function (e) { e.preventDefault(); });

    track.addEventListener('dblclick', function (e) {
      zoom.img = $('img', slides[index]);
      var p = point(e);
      if (zoom.scale > 1) resetZoom(); else zoomAt(p.x, p.y, 2.5);
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1, true); }
    });
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () { goTo(Number(b.getAttribute('data-ez-thumb')), true); });
    });
    window.addEventListener('resize', function () {
      resetZoom();
      track.scrollLeft = index * track.clientWidth;
    });

    var start = Number(track.getAttribute('data-start')) || 0;
    if (start > 0) goTo(start, false);
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    var main = $('[data-ez-main-add]');
    var sticky = $('[data-ez-sticky]');
    if (main && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        // The bar shows whenever the main button is off screen, above or below
        var off = !entries[0].isIntersecting;
        sticky.classList.toggle('is-on', off);
        document.body.classList.toggle('has-sticky', off);
      }).observe(main);
    }
    var link = $('[data-ez-rev-link]');
    var revs = $('[data-ez-reviews]');
    if (link && revs) {
      var total = Number(revs.getAttribute('data-total')) || 0;
      if (total > 0) {
        $('[data-ez-rev-count]', link).textContent = total + (total === 1 ? ' review' : ' reviews');
        link.hidden = false;
      }
    }
    var variant = $('[data-ez-variant]');
    if (variant) {
      variant.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.value);
        window.location.href = url.toString();
      });
    }
  }

  /* ---------- Reviews ---------- */
  function openWriteBox() {
    var box = $('[data-ez-write-box]');
    if (!box) return;
    box.hidden = false;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var name = $('#EzRevName', box);
    if (name) setTimeout(function () { name.focus({ preventScroll: true }); }, 350);
  }
  function initReviews() {
    var box = $('[data-ez-write-box]');
    if (!box) return;
    if ($('[data-ez-posted]', box) || $('.ez-note--err', box)) {
      box.hidden = false;
      box.scrollIntoView({ block: 'center' });
    }
    var form = $('form', box);
    if (form) {
      form.addEventListener('submit', function (e) {
        var rating = $('[data-ez-rate-input]', box);
        if (rating && !rating.value) {
          e.preventDefault();
          toast('Please choose a star rating.');
        }
      });
    }
  }

  /* ---------- Orders: cards, shared by Track order and Support ---------- */
  function backend() {
    var B = window.ezBackend;
    return B && B.available ? B : null;
  }
  function keep(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
    } catch (e) { /* storage can be blocked */ }
    return null;
  }
  var STAGES = {
    confirmed: { label: 'Order confirmed', text: 'We have your order. Books are printed and packed within 2 business days.', step: 0 },
    printed: { label: 'Printed, packing now', text: 'Your books are printed and being packed for the courier.', step: 1 },
    shipped: { label: 'Shipped', text: 'On its way with the courier.', step: 2 },
    cancelled: { label: 'Cancelled', text: 'This order was cancelled. If you did not expect that, ask our assistant on the Support page.', step: -1 }
  };
  var STEP_NAMES = ['Confirmed', 'Printed', 'Shipped', 'Delivered'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function dayLabel(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
    return m ? Number(m[3]) + ' ' + MONTHS[Number(m[2]) - 1] + ' ' + m[1] : '';
  }
  /* "2026-10-15T08:12", India time as the courier sends it, without converting it. */
  function courierTime(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(value || '');
    if (!m) return '';
    var h = Number(m[4]);
    return Number(m[3]) + ' ' + MONTHS[Number(m[2]) - 1] + ', ' + ((h % 12) || 12) + ':' + m[5] + (h < 12 ? ' AM' : ' PM');
  }
  function shortDay(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
    return m ? Number(m[3]) + ' ' + MONTHS[Number(m[2]) - 1] : '';
  }
  function when(ms) {
    if (!ms) return '';
    var d = new Date(ms);
    var today = new Date();
    var time = d.toLocaleTimeString('en-IN', { hour: 'numeric', minute: '2-digit' });
    if (d.toDateString() === today.toDateString()) return 'Today ' + time;
    return d.getDate() + ' ' + MONTHS[d.getMonth()] + ', ' + time;
  }
  /* Pictures the server sent: Firebase Storage over https, or the local emulator in tests. */
  function safeImage(url) {
    try {
      var u = new URL(url);
      return u.protocol === 'https:' || (u.protocol === 'http:' && /^(127\.0\.0\.1|localhost)$/.test(u.hostname)) ? u.href : null;
    } catch (e) { return null; }
  }
  function withParam(url, key, value) { return url + (url.indexOf('?') === -1 ? '?' : '&') + key + '=' + encodeURIComponent(value); }
  function withTopic(url, topic) { return withParam(url, 'topic', topic); }
  function looksLikeAwb(raw) {
    var v = raw.replace(/[\s\-–./#]/g, '');
    return /^[A-Za-z0-9]{8,24}$/.test(v) && (v.match(/\d/g) || []).length >= 6;
  }
  function mobileOf(raw) {
    var digits = String(raw || '').replace(/[\s\-()+]/g, '');
    return /^(91|0)?[6-9]\d{9}$/.test(digits) ? digits.slice(-10) : null;
  }
  function copyText(text, btn, label) {
    var done = function () { btn.textContent = 'Copied'; setTimeout(function () { btn.textContent = label || 'Copy'; }, 1600); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, function () { toast('Press and hold to copy it.'); });
    else toast('Press and hold to copy it.');
  }
  function money(n) { return '₹' + Number(n).toLocaleString('en-IN'); }

  /* The courier's live status (Delhivery), from the server. */
  function liveBlock(live, o) {
    var box = el('div', 'ez-live ez-live--' + (live.stage || 'in_transit'));
    var now = el('div', 'ez-live__now');
    now.appendChild(el('b', null, live.label));
    if (live.place) now.appendChild(el('span', null, ' · ' + live.place));
    box.appendChild(now);
    var detail = live.detail && live.detail.toLowerCase() !== String(live.label).toLowerCase() ? live.detail : '';
    var line = [detail, courierTime(live.at)].filter(Boolean).join(' · ');
    if (line) box.appendChild(el('div', 'ez-hint', line));
    if (live.expectedOn) box.appendChild(el('div', 'ez-live__eta', 'Expected by ' + shortDay(live.expectedOn)));
    else if (live.stage === 'out_for_delivery') box.appendChild(el('div', 'ez-live__eta', 'Arriving today'));
    else if (live.stage === 'awaiting_pickup' || live.stage === 'in_transit') {
      var when = usualArrival(o);
      if (when.text) box.appendChild(el('div', when.kind === 'usual' ? 'ez-live__eta' : 'ez-hint', when.text));
    }
    var events = live.events || [];
    if (events.length > 1) {
      var more = el('details', 'ez-events');
      more.appendChild(el('summary', null, 'All courier updates (' + events.length + ')'));
      var list = el('ol');
      events.forEach(function (e) {
        var li = el('li');
        li.appendChild(el('b', null, e.text));
        li.appendChild(el('span', 'ez-hint', [e.place, courierTime(e.at)].filter(Boolean).join(' · ')));
        list.appendChild(li);
      });
      more.appendChild(list);
      box.appendChild(more);
    }
    return box;
  }

  /* When it usually arrives, from the order date: 4–6 days after ordering, up to 8 for some
     places. Used when Delhivery gives no date (or there is no live status), and never as a
     link to the courier's own page, which asks customers for an SMS code. */
  function usualArrival(o) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(o.placedOn || '');
    if (!m) return { kind: 'unknown' };
    var placed = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    var day = function (n) { var d = new Date(placed); d.setDate(d.getDate() + n); return d; };
    var label = function (d) { return d.getDate() + ' ' + MONTHS[d.getMonth()]; };
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    if (today <= day(6)) return { kind: 'usual', text: 'Usually delivered by ' + label(day(6)) + '.' };
    if (today <= day(8)) return { kind: 'late', text: 'Some places take up to 8 days, so it should reach you by ' + label(day(8)) + '.' };
    return { kind: 'overdue', text: 'It is taking longer than usual, so our team can check it with the courier for you.' };
  }
  function shippedText(o) {
    var by = o.courier ? 'On its way with ' + o.courier + '.' : 'On its way with the courier.';
    var when = usualArrival(o);
    return when.text ? by + ' ' + when.text : by;
  }

  /** One order, built only from what the server sent. Every value goes in as text. */
  function orderCard(o, opts) {
    opts = opts || {};
    var key = STAGES[o.stage] ? o.stage : 'confirmed';
    var st = STAGES[key];
    var live = o.live || null;
    var delivered = live && live.stage === 'delivered';
    var card = el('article', 'ez-order' + (opts.compact ? ' ez-order--compact' : ''));
    var head = el('div', 'ez-order__head');
    head.appendChild(el('span', 'ez-stage ez-stage--' + (delivered ? 'delivered' : key), live && key === 'shipped' ? live.label : st.label));
    if (o.placedOn) head.appendChild(el('span', 'ez-hint', 'Ordered ' + dayLabel(o.placedOn)));
    card.appendChild(head);
    if (st.step >= 0) {
      var step = delivered ? 4 : st.step;
      var bar = el('ol', 'ez-progress');
      bar.setAttribute('aria-label', 'Order progress');
      STEP_NAMES.forEach(function (name, i) {
        var li = el('li', i < step ? 'is-done' : i === step ? 'is-now' : null, name);
        if (i === step) li.setAttribute('aria-current', 'step');
        bar.appendChild(li);
      });
      card.appendChild(bar);
    }
    if (live && key === 'shipped') card.appendChild(liveBlock(live, o));
    else card.appendChild(el('p', 'ez-order__text', key === 'shipped' ? shippedText(o) : st.text));
    var books = o.books || [];
    if (books.length || o.otherItems) {
      var list = el('ul', 'ez-order__books');
      books.forEach(function (t) { list.appendChild(el('li', null, t)); });
      if (o.otherItems) list.appendChild(el('li', 'ez-order__more', o.otherItems === 1 ? '1 more item' : o.otherItems + ' more items'));
      card.appendChild(list);
    }
    var kv = el('div', 'ez-kv ez-order__kv');
    function row(label, value, extra) {
      var r = el('div');
      r.appendChild(el('span', null, label));
      var v = el('span', null, value);
      if (extra) v.appendChild(extra);
      r.appendChild(v);
      kv.appendChild(r);
    }
    if (o.courier) row('Courier', o.courier);
    if (o.awb) {
      var copy = el('button', 'ez-copy', 'Copy');
      copy.type = 'button';
      copy.setAttribute('aria-label', 'Copy AWB number');
      copy.addEventListener('click', function () { copyText(o.awb, copy); });
      row('AWB number', o.awb, copy);
    }
    if (o.bookCount) row('Books', String(o.bookCount));
    if (kv.children.length) card.appendChild(kv);
    var acts = el('div', 'ez-order__acts');
    // Tracking stays on this site: the AWB alone opens it, with no sign-in or SMS code.
    if (opts.trackUrl && o.awb && key === 'shipped') {
      var tr = el('a', 'ez-btn ez-btn--ink', 'Track this order');
      tr.href = withParam(opts.trackUrl, 'awb', o.awb);
      tr.target = '_blank';
      tr.rel = 'noopener';
      acts.appendChild(tr);
    }
    if (opts.supportUrl) {
      var help = el('a', 'ez-btn', 'Problem with this order?');
      help.href = withTopic(opts.supportUrl, 'order');
      help.addEventListener('click', function () { store('ezSupportRef', o.awb || ('order of ' + dayLabel(o.placedOn))); });
      acts.appendChild(help);
    }
    if (acts.children.length) card.appendChild(acts);
    return card;
  }

  /* ---------- Track order ---------- */
  function initTrack() {
    var form = $('[data-ez-track]');
    if (!form) return;
    var B = backend();
    var input = $('#EzTrackInput', form);
    var go = $('[data-ez-track-go]', form);
    var msg = $('[data-ez-track-msg]', form);
    var out = $('[data-ez-track-out]');
    var head = $('[data-ez-track-head]');
    var supportUrl = form.getAttribute('data-support-url') || '';

    function say(kind, text, link) {
      msg.innerHTML = '';
      msg.hidden = false;
      msg.appendChild(el('div', 'ez-note ez-note--' + kind, text));
      if (link) {
        var a = el('a', 'ez-btn ez-btn--block', link.label);
        a.href = link.href;
        if (link.ref) a.addEventListener('click', function () { store('ezSupportRef', link.ref); });
        msg.appendChild(a);
      }
    }
    function quiet() { msg.innerHTML = ''; msg.hidden = true; }
    function clearOrders() { out.innerHTML = ''; out.hidden = true; head.hidden = true; }
    function busy(on) {
      go.disabled = on;
      go.setAttribute('aria-busy', String(on));
      form.classList.toggle('is-busy', on);
    }
    function help(ref) { return { label: 'Ask our assistant', href: withTopic(supportUrl, 'order'), ref: ref }; }
    function showCards(orders, title) {
      out.innerHTML = '';
      out.hidden = false;
      head.textContent = title || '';
      head.hidden = !title;
      orders.forEach(function (o) { out.appendChild(orderCard(o, { supportUrl: supportUrl })); });
      if (out.getBoundingClientRect().top > window.innerHeight - 80) out.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function lookup(raw, mobile) {
      busy(true);
      quiet();
      clearOrders();
      (mobile ? B.trackPhone(mobile) : B.trackAwb(raw)).then(function (res) {
        busy(false);
        if (res.orders.length) {
          showCards(res.orders, res.by === 'phone' ? (res.orders.length === 1 ? '1 order' : res.orders.length + ' orders') + ' on +91 ' + res.phone : '');
          return;
        }
        if (res.by === 'phone') say('err', 'We found no orders on +91 ' + res.phone + ' in the last year. Check the number you ordered with, or use the AWB number from your shipping message.', help(res.phone));
        else say('err', 'No order with this AWB number yet. Check the number in your shipping message. Shipped orders appear here within a day.', help(raw));
      }, function (e) {
        busy(false);
        say('err', B.explain(e).message, help(raw));
      });
    }

    // Without the backend (no Firebase config in theme settings): courier links or support, as before.
    function legacy(raw, mobile) {
      var template = form.getAttribute(mobile ? 'data-phone-url' : 'data-awb-url');
      if (template) {
        var value = mobile || raw;
        window.location.href = template.replace('{phone}', encodeURIComponent(value)).replace('{awb}', encodeURIComponent(value));
        return;
      }
      say('ok', mobile
        ? 'We look up orders by phone number through support. Share your details and our team checks the order for you.'
        : 'Your tracking link is in the shipping email and WhatsApp message that came with this AWB number. Our team can also check it for you.',
        { label: mobile ? 'Check my order with support' : 'Ask support about this AWB', href: withTopic(supportUrl, 'order'), ref: raw });
    }

    function submit() {
      var raw = input.value.trim();
      quiet();
      if (!raw) {
        say('err', 'Enter your AWB number or the phone number you ordered with.');
        input.focus();
        return;
      }
      var mobile = mobileOf(raw);
      if (!B) { legacy(raw, mobile); return; }
      if (mobile || looksLikeAwb(raw)) { lookup(raw, mobile); return; }
      say('err', 'That is not an AWB number or a 10-digit mobile number. The AWB number is in your shipping SMS, email or WhatsApp.');
      input.focus();
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });

    // A link with ?awb=… (from the assistant, or one the team sends) opens straight on that order.
    var linked = new URLSearchParams(window.location.search).get('awb');
    if (linked && B && looksLikeAwb(linked)) {
      input.value = linked.slice(0, 40);
      submit();
    }
  }

  function readAssistantFlag() {
    try { return JSON.parse($('#EzBackendConfig').textContent).assistant !== false; } catch (e) { return false; }
  }

  /* ---------- Photos: shrunk in the browser (smaller upload, no location data) ---------- */
  function shrinkPhoto(file) {
    return new Promise(function (resolve, reject) {
      if (!file || !/^image\//.test(file.type || 'image/')) { reject(new Error('Choose a photo.')); return; }
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        var attempt = function (max, quality) {
          var scale = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
          var canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
          canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
          return canvas.toDataURL('image/jpeg', quality);
        };
        var dataUrl = attempt(1600, 0.82);
        if (dataUrl.length > 3200000) dataUrl = attempt(1200, 0.7);
        resolve({ data: dataUrl.slice(dataUrl.indexOf(',') + 1), preview: dataUrl });
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('That photo could not be opened. Try a JPG or PNG.')); };
      img.src = url;
    });
  }
  function photoChip(box, photo, onRemove) {
    box.innerHTML = '';
    box.hidden = !photo;
    if (!photo) return;
    var img = el('img', 'ez-thumb');
    img.src = photo.preview;
    img.alt = 'Photo to send';
    box.appendChild(img);
    box.appendChild(el('span', 'ez-hint', 'Photo ready to send'));
    var x = el('button', 'ez-linkbtn', 'Remove');
    x.type = 'button';
    x.addEventListener('click', onRemove);
    box.appendChild(x);
  }

  /* ---------- Support: details, assistant, our team, and the customer's requests ---------- */
  var REQUESTS_KEY = 'ezRequests';
  function loadRequests() {
    try {
      var list = JSON.parse(keep(REQUESTS_KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (r) { return r && typeof r.id === 'string' && typeof r.key === 'string'; }).slice(0, 10) : [];
    } catch (e) { return []; }
  }
  function rememberRequest(r) {
    var list = loadRequests().filter(function (x) { return x.id !== r.id; });
    list.unshift({ id: r.id, key: r.key, ref: r.ref || '', title: r.title || '' });
    keep(REQUESTS_KEY, JSON.stringify(list.slice(0, 10)));
  }

  function initSupport() {
    var root = $('[data-ez-support]');
    if (!root) return;
    var state = { step: 1, topic: null, log: [], convo: [], shownOrders: [], waiting: false, chatRequest: null, chatPhoto: null, formPhoto: null, threadPhoto: null, thread: null, poll: null };
    var dots = $$('[data-ez-stepdot]', root);
    var stepNav = $('[data-ez-stepnav]', root);
    var hours = root.getAttribute('data-hours') || '';
    function setStep(n, allDone) {
      dots.forEach(function (d) {
        var i = Number(d.getAttribute('data-ez-stepdot'));
        d.classList.toggle('is-done', allDone || i < n);
        d.classList.toggle('is-now', !allDone && i === n);
      });
      $$('[data-ez-step]', root).forEach(function (s) { s.hidden = Number(s.getAttribute('data-ez-step')) !== n; });
      state.step = n;
    }

    var done = $('[data-ez-support-done]', root);
    if (done) {
      setStep(3, true);
      try {
        var saved = JSON.parse(store('ezSupport') || 'null');
        var summary = $('[data-ez-support-summary]', root);
        if (saved && summary) {
          ['name', 'phone', 'topic'].forEach(function (k) { $('[data-k="' + k + '"]', summary).textContent = saved[k] || ''; });
          summary.hidden = false;
        }
      } catch (e) { /* nothing to show */ }
      store('ezSupport', null);
      store('ezSupportRef', null);
      return;
    }

    var kbEl = $('[data-ez-kb]');
    var KB = { topics: [], links: {} };
    try { KB = JSON.parse(kbEl.textContent); } catch (e) { /* keep the empty one */ }
    var form = $('#EzSupportForm');
    var nameIn = $('#EzSupName'), phoneIn = $('#EzSupPhone'), emailIn = $('#EzSupEmail'), bodyIn = $('#EzSupBody'), orderIn = $('#EzSupOrder');
    var topicBox = $('[data-ez-topics]', root), chat = $('[data-ez-chat]', root), quick = $('[data-ez-quick]', root), msgIn = $('#EzSupMsg');
    var params = new URLSearchParams(window.location.search);
    var ref = store('ezSupportRef') || params.get('ref') || '';
    var B = backend();
    var aiOn = Boolean(B && readAssistantFlag());

    function topicByKey(key) { return KB.topics.filter(function (t) { return t.key === key; })[0]; }
    var wanted = topicByKey(params.get('topic')) || topicByKey('order') || KB.topics[0];
    state.topic = wanted;

    KB.topics.forEach(function (t) {
      if ((t.hidden || t.quick) && t !== wanted) return;
      var b = el('button', 'ez-chip ez-chip--sm', t.label);
      b.type = 'button';
      b.setAttribute('aria-pressed', String(t === wanted));
      b.addEventListener('click', function () {
        state.topic = t;
        $$('button', topicBox).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      });
      topicBox.appendChild(b);
    });

    function scrollChat() { chat.scrollTop = chat.scrollHeight; }
    function bubble(text, mine, quietly) {
      var m = el('div', 'ez-msg' + (mine ? ' ez-msg--me' : ''));
      m.appendChild(el('div', null, text));
      chat.appendChild(m);
      scrollChat();
      if (!quietly) {
        state.log.push((mine ? 'Me: ' : 'Assistant: ') + text);
        state.convo.push({ role: mine ? 'user' : 'assistant', text: text });
      }
      return m;
    }
    function actions(m, list) {
      var row = el('div', 'ez-msg__acts');
      list.forEach(function (a) {
        var b = el(a.href ? 'a' : 'button', 'ez-btn' + (a.cls ? ' ' + a.cls : ''), a.label);
        if (a.href) { b.href = a.href; if (a.blank) { b.target = '_blank'; b.rel = 'noopener'; } } else { b.type = 'button'; b.addEventListener('click', a.run); }
        row.appendChild(b);
      });
      m.appendChild(row);
      scrollChat();
    }

    /* Without the assistant: the built-in answers, as before. */
    function askSolved() {
      var m = bubble('Did that solve it?');
      actions(m, [
        { label: 'Yes, thanks', cls: 'ez-btn--yes', run: function () {
          bubble('Yes, thanks', true);
          var end = bubble('Glad that helped. Happy studying!');
          actions(end, [{ label: 'Back to shopping', href: KB.links.home || '/' }]);
        } },
        { label: 'No, send it to our team', run: toHuman }
      ]);
    }
    function answer(t) {
      state.topic = t;
      var m = bubble(t.answer);
      var acts = [];
      if (t.link && KB.links[t.link]) acts.push({ label: t.linkLabel || 'Open', href: KB.links[t.link] });
      if (acts.length) actions(m, acts);
      if (t.key === 'other') { msgIn.focus(); return; }
      if (t.key === 'restock' || t.quick) {
        var next = bubble('Shall I send this to our team now?');
        actions(next, [{ label: 'Yes, send it', cls: 'ez-btn--yes', run: toHuman }]);
        return;
      }
      askSolved();
    }
    function fillQuick() {
      quick.innerHTML = '';
      if (aiOn) return;
      KB.topics.forEach(function (t) {
        if (t.hidden || t.key === 'other') return;
        var b = el('button', null, t.label);
        b.type = 'button';
        b.addEventListener('click', function () { bubble(t.label, true); answer(t); });
        quick.appendChild(b);
      });
    }
    function localReply(text) {
      var low = text.toLowerCase();
      var best = null, score = 0;
      KB.topics.forEach(function (t) {
        var s = 0;
        (t.words || []).forEach(function (w) { if (low.indexOf(w) !== -1) s += 1; });
        if (s > score) { score = s; best = t; }
      });
      if (best) { answer(best); return; }
      var m = bubble('I could not find an answer to that. Our team can help with it.');
      actions(m, [{ label: 'Send it to our team', run: toHuman }]);
    }

    function validStart() {
      var okName = nameIn.value.trim().length >= 2;
      var okPhone = Boolean(mobileOf(phoneIn.value));
      $('[data-ez-step1-error]', root).hidden = okName && okPhone;
      if (!okName) nameIn.focus(); else if (!okPhone) phoneIn.focus();
      return okName && okPhone;
    }
    function firstName() { return nameIn.value.trim().split(' ')[0]; }
    function start() {
      if (!validStart()) return;
      keep('ezSupportMe', JSON.stringify({ name: nameIn.value.trim(), phone: phoneIn.value.trim() }));
      hideRequests();
      setStep(2);
      chat.innerHTML = '';
      state.log = [];
      state.convo = [];
      state.shownOrders = [];
      fillQuick();
      if (!aiOn) {
        bubble('Hi ' + firstName() + ', I am the Ezee Notes assistant. I can explain delivery, returns and payment, or help you choose a book.');
        bubble(state.topic.label + (ref ? ' (' + ref + ')' : ''), true);
        answer(state.topic);
        return;
      }
      // The greeting is the page's, not the model's: it is not sent as part of the chat.
      bubble('Hi ' + firstName() + ', I am the Ezee Notes assistant. I can check your orders and the courier, help you choose books, and send anything else to our team for you.', false, true);
      if (state.topic.key === 'other' && !ref) {
        bubble('Tell me what you need in a line or two.', false, true);
        msgIn.focus();
        return;
      }
      var opening = state.topic.label + (ref ? ' (' + ref + ')' : '');
      bubble(opening, true);
      askAssistant();
    }
    function send() {
      var text = msgIn.value.trim();
      if (!text || state.waiting) return;
      msgIn.value = '';
      bubble(text, true);
      if (aiOn) askAssistant(); else localReply(text);
    }

    /* The Ezee assistant (server: storefrontChat). Orders, books and requests arrive as
       cards the server built; the model's own text is shown as plain text only. */
    function typing() {
      var m = el('div', 'ez-msg ez-typing');
      m.setAttribute('aria-label', 'Assistant is typing');
      for (var i = 0; i < 3; i += 1) m.appendChild(el('span'));
      chat.appendChild(m);
      scrollChat();
      return m;
    }
    function card(node) {
      var wrap = el('div', 'ez-msg ez-msg--card');
      wrap.appendChild(node);
      chat.appendChild(wrap);
      scrollChat();
      return wrap;
    }
    function showOrders(list) {
      (list || []).forEach(function (o) {
        // An order already on screen is not repeated (a lookup for a request finds it again).
        var id = [o.placedOn, o.awb, (o.books || []).join(',')].join('|');
        if (state.shownOrders.indexOf(id) !== -1) return;
        state.shownOrders.push(id);
        card(orderCard(o, { compact: true, trackUrl: KB.links.track }));
        state.log.push('Order: ' + [STAGES[o.stage] ? STAGES[o.stage].label : o.stage, o.awb ? 'AWB ' + o.awb : ''].filter(Boolean).join(', '));
      });
    }
    function bookCard(b) {
      var a = el('a', 'ez-bookcard');
      a.href = b.path && b.path.charAt(0) === '/' ? b.path : '#';
      a.target = '_blank';
      a.rel = 'noopener';
      if (b.image) {
        var img = el('img');
        img.src = withParam(b.image, 'width', '160');
        img.alt = '';
        img.loading = 'lazy';
        a.appendChild(img);
      }
      var txt = el('span', 'ez-bookcard__txt');
      txt.appendChild(el('b', null, b.title));
      var price = el('span', 'ez-bookcard__price', money(b.price));
      if (b.mrp) price.appendChild(el('s', null, money(b.mrp)));
      txt.appendChild(price);
      if (!b.inStock) txt.appendChild(el('span', 'ez-soldout', 'Out of stock'));
      a.appendChild(txt);
      a.appendChild(el('span', 'ez-bookcard__go', 'View'));
      return a;
    }
    function showBooks(list) {
      if (!list || !list.length) return;
      var box = el('div', 'ez-books');
      list.forEach(function (b) { box.appendChild(bookCard(b)); });
      card(box);
    }
    function requestCard(r) {
      var box = el('div', 'ez-reqcard');
      box.appendChild(el('b', null, r.added ? 'Added to your request ' + r.ticket.ref : 'Sent to our team · Request ' + r.ticket.ref));
      box.appendChild(el('span', 'ez-hint', 'Their replies show here and under Your requests' + (hours ? ', ' + hours : '') + '.'));
      var open = el('button', 'ez-btn', 'Open request');
      open.type = 'button';
      open.addEventListener('click', function () { openThread(r.ticket.id); });
      box.appendChild(open);
      card(box);
    }
    function filed(r) {
      rememberRequest({ id: r.ticket.id, key: r.key, ref: r.ticket.ref, title: r.ticket.title });
      state.chatRequest = { id: r.ticket.id, key: r.key, ref: r.ticket.ref };
      setChatPhoto(null);
      state.log.push('Request sent: ' + r.ticket.ref);
    }
    function offer(action, m) {
      if (action === 'open_tracking' && KB.links.track) actions(m, [{ label: 'Track my order', href: KB.links.track, blank: true }]);
      else if (action === 'browse_books' && KB.links.home) actions(m, [{ label: 'See all classes', href: KB.links.home, blank: true }]);
      else if (action === 'add_photo') actions(m, [{ label: 'Add a photo', cls: 'ez-btn--ink', run: function () { pickPhoto('chat'); } }]);
      else if (action === 'talk_to_team') actions(m, [{ label: 'Send it to our team', run: toHuman }]);
    }
    function askAssistant() {
      state.waiting = true;
      sendBtn.disabled = true;
      var dots = typing();
      var convo = state.convo.slice(-20).map(function (c) {
        return { role: c.role, text: c.text.slice(0, c.role === 'user' ? 800 : 1500) };
      });
      while (convo.length && convo[0].role !== 'user') convo.shift();
      var lastText = convo.length ? convo[convo.length - 1].text : '';
      var payload = {
        messages: convo,
        firstName: firstName(),
        name: nameIn.value.trim(),
        phone: mobileOf(phoneIn.value) || '',
        tickets: loadRequests().map(function (r) { return { id: r.id, key: r.key }; }),
        current: state.chatRequest,
        photo: state.chatPhoto ? { data: state.chatPhoto.data } : null
      };
      B.chat(payload).then(function (res) {
        dots.remove();
        if (res.request) filed(res.request);
        if (res.fallback) {
          showOrders(res.orders);
          if (res.request) requestCard(res.request);
          bubble('I cannot reach my answers right now, so here is what I know.', false, true);
          localReply(lastText);
          return;
        }
        var m = bubble(res.reply);
        showOrders(res.orders);
        showBooks(res.books);
        if (res.request) requestCard(res.request);
        var t = topicByKey(res.topic);
        if (t && t.key !== 'other') state.topic = t;
        offer(res.action, m);
        // Cards can be taller than the chat: start the view at the reply, not at the last card.
        if (chat.scrollHeight - m.offsetTop > chat.clientHeight) chat.scrollTop = Math.max(0, m.offsetTop - 8);
      }, function (e) {
        dots.remove();
        var why = B.explain(e);
        if (why.code === 'functions/resource-exhausted') {
          var m = bubble('You have sent a lot of messages. Please wait a few minutes, or send it to our team now.', false, true);
          actions(m, [{ label: 'Send it to our team', run: toHuman }]);
        } else {
          localReply(lastText);
        }
      }).then(function () {
        state.waiting = false;
        sendBtn.disabled = false;
      });
    }

    /* Photos: in the chat (with the next request, or straight onto the one already sent),
       on the form, and on a request's thread. */
    var photoInput = $('[data-ez-photo-input]', root);
    var photoFor = null;
    function pickPhoto(where) {
      photoFor = where;
      photoInput.value = '';
      photoInput.click();
    }
    function setChatPhoto(p) {
      state.chatPhoto = p;
      photoChip($('[data-ez-chat-photo]', root), null);
    }
    photoInput.addEventListener('change', function () {
      var file = photoInput.files && photoInput.files[0];
      if (!file) return;
      var where = photoFor;
      shrinkPhoto(file).then(function (photo) {
        if (where === 'form') {
          state.formPhoto = photo;
          photoChip($('[data-ez-form-photo]', root), photo, function () { state.formPhoto = null; photoChip($('[data-ez-form-photo]', root), null); });
        } else if (where === 'thread') {
          state.threadPhoto = photo;
          photoChip($('[data-ez-thread-photo]', root), photo, function () { state.threadPhoto = null; photoChip($('[data-ez-thread-photo]', root), null); });
        } else if (state.chatRequest) {
          var mine = el('div', 'ez-msg ez-msg--me');
          var img = el('img', 'ez-thumb ez-thumb--lg');
          img.src = photo.preview;
          img.alt = 'Your photo';
          mine.appendChild(img);
          chat.appendChild(mine);
          scrollChat();
          B.support({ op: 'reply', id: state.chatRequest.id, key: state.chatRequest.key, photo: { data: photo.data } }).then(function () {
            bubble('Photo added to your request ' + state.chatRequest.ref + '. Our team will see it with your request.', false, true);
          }, function (e) { bubble(B.explain(e).message, false, true); });
        } else {
          state.chatPhoto = photo;
          var me = el('div', 'ez-msg ez-msg--me');
          var pic = el('img', 'ez-thumb ez-thumb--lg');
          pic.src = photo.preview;
          pic.alt = 'Your photo';
          me.appendChild(pic);
          chat.appendChild(me);
          state.convo.push({ role: 'user', text: 'Here is a photo.' });
          state.log.push('Me: [photo]');
          scrollChat();
          if (aiOn && !state.waiting) askAssistant();
        }
      }, function (err) { toast(err.message); });
    });

    /* Step 3: the customer writes to the team. With the backend it becomes a request in the
       team's inbox; without it, the Shopify contact form emails the store, as before. */
    function toHuman() {
      if (B && state.chatRequest) { openThread(state.chatRequest.id); return; }
      setStep(3);
      $('[data-ez-topic-input]', root).value = state.topic ? state.topic.label : '';
      if (ref && orderIn && !orderIn.value) orderIn.value = ref;
      if (B) {
        $('[data-ez-photo-field]', root).hidden = false;
        $('[data-ez-chat-attached]', root).hidden = !state.convo.some(function (c) { return c.role === 'user'; });
        $('[data-ez-email-label]', root).textContent = 'Email (optional)';
        emailIn.required = false;
        bodyIn.focus();
      } else {
        if (!bodyIn.value) bodyIn.value = 'About: ' + (state.topic ? state.topic.label : '') + (ref ? '\nReference: ' + ref : '') + '\n\n(Write anything else here)\n\nChat with the assistant:\n' + state.log.join('\n');
        emailIn.focus();
      }
    }
    function step3Error(text) {
      var box = $('[data-ez-step3-error]', root);
      box.textContent = text || '';
      box.hidden = !text;
    }
    function sendToTeam() {
      var email = emailIn.value.trim();
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { step3Error('That email address does not look right.'); emailIn.focus(); return; }
      if (!bodyIn.value.trim() && !state.formPhoto) { step3Error('Please write a short message for our team.'); bodyIn.focus(); return; }
      step3Error('');
      var btn = $('[data-ez-step3-send]', root);
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      B.support({
        op: 'open',
        name: nameIn.value.trim(),
        phone: mobileOf(phoneIn.value) || phoneIn.value,
        email: email,
        topic: state.topic ? state.topic.key : 'other',
        message: bodyIn.value.trim(),
        orderRef: orderIn.value.trim(),
        transcript: state.convo.slice(-30),
        photo: state.formPhoto ? { data: state.formPhoto.data } : null
      }).then(function (res) {
        rememberRequest({ id: res.ticket.id, key: res.key, ref: res.ticket.ref, title: res.ticket.title });
        state.chatRequest = { id: res.ticket.id, key: res.key, ref: res.ticket.ref };
        bodyIn.value = '';
        state.formPhoto = null;
        photoChip($('[data-ez-form-photo]', root), null);
        showThread(res, { justSent: true });
      }, function (e) {
        step3Error(B.explain(e).message);
      }).then(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
    }

    /* Your requests, and one request's thread with the team's replies. */
    var reqBox = $('[data-ez-requests]', root), reqList = $('[data-ez-reqlist]', root);
    var threadBox = $('[data-ez-thread]', root), threadMsgs = $('[data-ez-thread-msgs]', root), threadIn = $('#EzThreadMsg');
    var formEl = form;
    function hideRequests() { reqBox.hidden = true; }
    function statusPill(t) {
      var pill = el('span', 'ez-reqstatus ez-reqstatus--' + t.status, t.statusLabel);
      return pill;
    }
    function renderRequests(list) {
      reqList.innerHTML = '';
      list.forEach(function (t) {
        var li = el('li');
        var b = el('button', 'ez-reqrow' + (t.unread ? ' is-unread' : ''));
        b.type = 'button';
        var top = el('span', 'ez-reqrow__top');
        top.appendChild(el('b', null, t.title));
        top.appendChild(statusPill(t));
        b.appendChild(top);
        b.appendChild(el('span', 'ez-reqrow__last', (t.unread ? 'New reply · ' : '') + (t.lastMessage || '')));
        b.appendChild(el('span', 'ez-hint', 'Request ' + t.ref + ' · ' + when(t.updatedAt)));
        b.addEventListener('click', function () { openThread(t.id); });
        li.appendChild(b);
        reqList.appendChild(li);
      });
      var unread = list.filter(function (t) { return t.unread; }).length;
      $('[data-ez-requests-note]', root).textContent = unread ? (unread === 1 ? '1 new reply' : unread + ' new replies') : '';
      reqBox.hidden = !list.length || state.step !== 1 || !threadBox.hidden;
    }
    function refreshRequests() {
      var held = loadRequests();
      if (!B || !held.length) { reqBox.hidden = true; return; }
      B.support({ op: 'list', tickets: held.map(function (r) { return { id: r.id, key: r.key }; }) }).then(function (res) {
        var ids = res.tickets.map(function (t) { return t.id; });
        keep(REQUESTS_KEY, JSON.stringify(held.filter(function (r) { return ids.indexOf(r.id) !== -1; })));
        renderRequests(res.tickets);
      }, function () { /* the list is a convenience; the page works without it */ });
    }
    function threadMessage(m) {
      var mine = m.from !== 'team';
      var box = el('div', 'ez-msg' + (mine ? ' ez-msg--me' : '') + (m.from === 'assistant' ? ' ez-msg--assist' : ''));
      box.appendChild(el('span', 'ez-msg__who', m.from === 'team' ? 'Ezee Notes team' : m.from === 'assistant' ? 'Sent by the assistant for you' : 'You'));
      var src = m.image ? safeImage(m.image) : null;
      if (src) {
        var link = el('a');
        link.href = src;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        var img = el('img', 'ez-thumb ez-thumb--lg');
        img.src = src;
        img.alt = 'Photo';
        img.loading = 'lazy';
        link.appendChild(img);
        box.appendChild(link);
      }
      if (m.text) box.appendChild(el('div', 'ez-msg__text', m.text));
      box.appendChild(el('span', 'ez-msg__at', when(m.at)));
      return box;
    }
    function showThread(res, opts) {
      opts = opts || {};
      var t = res.ticket;
      state.thread = { id: t.id, key: (loadRequests().filter(function (r) { return r.id === t.id; })[0] || {}).key || res.key };
      stepNav.hidden = true;
      formEl.hidden = true;
      reqBox.hidden = true;
      threadBox.hidden = false;
      $('[data-ez-thread-title]', root).textContent = t.title;
      var status = $('[data-ez-thread-status]', root);
      status.className = 'ez-reqstatus ez-reqstatus--' + t.status;
      status.textContent = t.statusLabel;
      $('[data-ez-thread-ref]', root).textContent = t.ref;
      threadMsgs.innerHTML = '';
      if (opts.justSent) threadMsgs.appendChild(el('div', 'ez-note ez-note--ok', 'Sent to our team. Keep the code ' + t.ref + ': replies show here on this browser, and you can open it on another device with your phone number and the code.'));
      res.messages.forEach(function (m) { threadMsgs.appendChild(threadMessage(m)); });
      threadMsgs.scrollTop = threadMsgs.scrollHeight;
      $('[data-ez-thread-compose]', root).hidden = t.closed;
      $('[data-ez-thread-closed]', root).hidden = !t.closed;
      startPolling();
      if (opts.focus !== false && !t.closed) threadBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function openThread(id) {
      var held = loadRequests().filter(function (r) { return r.id === id; })[0];
      if (!held || !B) return;
      B.support({ op: 'thread', id: held.id, key: held.key }).then(function (res) { showThread(res); }, function (e) { toast(B.explain(e).message); });
    }
    function startPolling() {
      stopPolling();
      state.poll = setInterval(function () {
        if (!state.thread || threadBox.hidden || document.visibilityState !== 'visible') return;
        B.support({ op: 'thread', id: state.thread.id, key: state.thread.key }).then(function (res) {
          if (threadBox.hidden || !state.thread || res.ticket.id !== state.thread.id) return;
          var count = $$('.ez-msg', threadMsgs).length;
          if (res.messages.length !== count || res.ticket.closed !== threadBox.classList.contains('is-closed')) showThread(res, { focus: false });
          threadBox.classList.toggle('is-closed', res.ticket.closed);
        }, function () { /* try again next time */ });
      }, 20000);
    }
    function stopPolling() { if (state.poll) clearInterval(state.poll); state.poll = null; }
    function closeThread() {
      stopPolling();
      state.thread = null;
      threadBox.hidden = true;
      stepNav.hidden = false;
      formEl.hidden = false;
      setStep(state.step === 3 ? 2 : state.step);
      if (state.step === 1) refreshRequests();
    }
    function sendReply() {
      var text = threadIn.value.trim();
      if ((!text && !state.threadPhoto) || !state.thread) return;
      var btn = $('[data-ez-thread-send]', root);
      btn.disabled = true;
      B.support({ op: 'reply', id: state.thread.id, key: state.thread.key, text: text, photo: state.threadPhoto ? { data: state.threadPhoto.data } : null }).then(function (res) {
        threadIn.value = '';
        state.threadPhoto = null;
        photoChip($('[data-ez-thread-photo]', root), null);
        showThread(res, { focus: false });
      }, function (e) { toast(B.explain(e).message); }).then(function () { btn.disabled = false; });
    }

    /* Another device: phone number plus request code. */
    var find = $('[data-ez-find]', root);
    if (B && find) {
      find.hidden = false;
      var findBox = $('[data-ez-find-box]', root), findMsg = $('[data-ez-find-msg]', root);
      $('[data-ez-find-open]', root).addEventListener('click', function (e) {
        findBox.hidden = !findBox.hidden;
        e.currentTarget.setAttribute('aria-expanded', String(!findBox.hidden));
        if (!findBox.hidden) $('#EzFindPhone').focus();
      });
      $('[data-ez-find-go]', root).addEventListener('click', function () {
        findMsg.hidden = true;
        B.support({ op: 'find', phone: $('#EzFindPhone').value, ref: $('#EzFindRef').value }).then(function (res) {
          rememberRequest({ id: res.ticket.id, key: res.key, ref: res.ticket.ref, title: res.ticket.title });
          showThread(res);
        }, function (e) {
          findMsg.textContent = B.explain(e).message;
          findMsg.hidden = false;
        });
      });
    }

    $('[data-ez-start]', root).addEventListener('click', start);
    var sendBtn = $('[data-ez-send]', root);
    sendBtn.addEventListener('click', send);
    var aiNote = $('[data-ez-ai-note]', root);
    if (aiNote) aiNote.hidden = !aiOn;
    var chatPhotoBtn = $('[data-ez-photo-pick="chat"]', root);
    if (chatPhotoBtn) chatPhotoBtn.hidden = !aiOn;
    $$('[data-ez-photo-pick]', root).forEach(function (b) {
      b.addEventListener('click', function () { pickPhoto(b.getAttribute('data-ez-photo-pick')); });
    });
    $('[data-ez-human]', root).addEventListener('click', toHuman);
    $('[data-ez-back]', root).addEventListener('click', function () { setStep(2); });
    $('[data-ez-thread-back]', root).addEventListener('click', closeThread);
    $('[data-ez-thread-send]', root).addEventListener('click', sendReply);
    $('[data-ez-thread-new]', root).addEventListener('click', function () {
      state.chatRequest = null;
      closeThread();
      setStep(1);
      refreshRequests();
    });
    threadIn.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendReply(); } });
    [nameIn, phoneIn].forEach(function (i) {
      i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); start(); } });
    });
    msgIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); send(); } });
    form.addEventListener('submit', function (e) {
      if (!validStart()) { e.preventDefault(); setStep(1); return; }
      if (B) { e.preventDefault(); sendToTeam(); return; }
      var okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailIn.value.trim());
      if (!okEmail) { e.preventDefault(); toast('Please enter a valid email so we can reply.'); emailIn.focus(); return; }
      if (!bodyIn.value.trim()) { e.preventDefault(); toast('Please write a short message.'); bodyIn.focus(); return; }
      store('ezSupport', JSON.stringify({ name: nameIn.value.trim(), phone: phoneIn.value.trim(), topic: state.topic ? state.topic.label : '' }));
    });

    // A returning customer does not type their name and number again on this device.
    try {
      var me = JSON.parse(keep('ezSupportMe') || 'null');
      if (me && !nameIn.value && !phoneIn.value) { nameIn.value = me.name || ''; phoneIn.value = me.phone || ''; }
    } catch (e) { /* nothing saved */ }
    if ($('[data-ez-support-error]', root)) setStep(3); else setStep(1);
    refreshRequests();
  }

  /* ---------- Clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    if (t.tagName === 'DIALOG' && t.classList.contains('ez-dialog')) { closeDialog(t); return; }

    var hit;
    if ((hit = t.closest('[data-ez-close]'))) { closeDialog(hit.closest('dialog')); return; }

    if ((hit = t.closest('[data-ez-open]'))) {
      var d = document.getElementById(hit.getAttribute('data-ez-open'));
      openDialog(d);
      var focusId = hit.getAttribute('data-ez-focus');
      if (focusId) { var f = document.getElementById(focusId); if (f) setTimeout(function () { f.focus(); }, 60); }
      return;
    }

    if ((hit = t.closest('[data-ez-add]'))) { e.preventDefault(); addToCart(hit.getAttribute('data-ez-add'), hit, true); return; }

    if ((hit = t.closest('[data-ez-addon]'))) {
      if (hit.getAttribute('aria-pressed') === 'true' && hit.getAttribute('data-key')) changeLine(hit.getAttribute('data-key'), 0, hit);
      else addToCart(hit.getAttribute('data-ez-addon'), hit, false);
      return;
    }

    if ((hit = t.closest('[data-ez-qty]'))) { changeLine(hit.getAttribute('data-key'), Number(hit.getAttribute('data-ez-qty')), hit); return; }

    if ((hit = t.closest('[data-ez-pick]'))) {
      var picker = hit.closest('[data-ez-picker]');
      var idx = hit.getAttribute('data-ez-pick');
      $$('[data-ez-pick]', picker).forEach(function (b) { b.setAttribute('aria-pressed', String(b === hit)); });
      $$('[data-ez-panel]', picker).forEach(function (p) { p.hidden = p.getAttribute('data-ez-panel') !== idx; });
      return;
    }

    if ((hit = t.closest('[data-ez-ig-play]'))) { mountInstagram(hit.closest('[data-ez-ig]')); return; }
    if ((hit = t.closest('[data-ez-video], [data-ez-video-src]'))) { e.preventDefault(); playVideo(hit); return; }
    if ((hit = t.closest('[data-ez-zoom]'))) { var im = $('img', hit); zoomImage(hit.getAttribute('data-ez-zoom'), im ? im.alt : ''); return; }

    if ((hit = t.closest('[data-ez-sample]'))) { openSample(hit); return; }

    if ((hit = t.closest('[data-ez-rev-all]'))) {
      $$('[data-ez-rev]', hit.closest('[data-ez-reviews]')).forEach(function (r) { r.hidden = false; });
      hit.hidden = true;
      return;
    }
    if ((hit = t.closest('[data-ez-write]'))) { e.preventDefault(); openWriteBox(); return; }

    if ((hit = t.closest('[data-star]'))) {
      var n = Number(hit.getAttribute('data-star'));
      var rate = hit.closest('[data-ez-rate]');
      $$('[data-star]', rate).forEach(function (b) {
        var on = Number(b.getAttribute('data-star')) <= n;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-star')) === n));
      });
      var input = $('[data-ez-rate-input]', rate.parentNode);
      if (input) input.value = n + ' out of 5';
      return;
    }
  });

  function init() {
    initShelf();
    initGallery();
    initInstagram();
    initProduct();
    initReviews();
    initTrack();
    initSupport();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
